import { render, staticRenderFns } from "./UserFeedback.vue?vue&type=template&id=7c87961a&scoped=true"
import script from "./UserFeedback.vue?vue&type=script&lang=js"
export * from "./UserFeedback.vue?vue&type=script&lang=js"
import style0 from "./UserFeedback.vue?vue&type=style&index=0&id=7c87961a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c87961a",
  null
  
)

export default component.exports